import React from 'react';

import DataSelect from '../common/DataSelect';
import { useGetModelsQuery } from '../../redux/services/modelApi';

const SelectModelInput = ({
  label = 'Model',
  ...props
}) => {
  return (
    <DataSelect
      defaultValue={1}
      useGetQuery={useGetModelsQuery}
      label={props?.hideLabel ? null : label}
      mapRowToOption={model => ({
        value: model.id || model.name,
        label: `${model.vendor} - ${model.model_name}`
      })}
      {...props}
    />
  );
};

export default SelectModelInput;

